import { render, staticRenderFns } from "./SubjectForm.vue?vue&type=template&id=365b476a&scoped=true&"
import script from "./SubjectForm.vue?vue&type=script&lang=js&"
export * from "./SubjectForm.vue?vue&type=script&lang=js&"
import style0 from "./SubjectForm.vue?vue&type=style&index=0&id=365b476a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365b476a",
  null
  
)

export default component.exports